<template>
  <MenuItems :modulosArray="modulosArray" :accesos="accesos" :collapsed="isMenuCollapsed" />

  <a-drawer
    title="Menu de opciones"
    placement="left"
    v-model:visible="isCollapsed"
    :closable="true"
    class="midrawer"
    @close="setCollapsed"
  >
    <MenuItems :modulosArray="modulosArray" :accesos="accesos" />
  </a-drawer>
</template>

<script>
import { useStore } from "vuex";
import { ref, watch, computed } from "vue";
import MenuItems from "./MenuItems.vue";
import { generateModules } from "@/utils";

export default {
  components: {
    MenuItems
  },
  setup() {
    const store = useStore();
    const isCollapsed = ref(store.state.navegacion.isCollapsed);
    const isMenuCollapsed = ref(store.state.navegacion.isMenuCollapsed);
    const modulos = store.state.usuarios.modulos;

    function setCollapsed() {
      store.dispatch("navegacion/setCollapsed");
    }

    function toggleCollapsed() {
      store.dispatch("navegacion/toggleCollapsed");
    }

    watch(store.state.navegacion, () => {
      isCollapsed.value = store.state.navegacion.isCollapsed;
    });

    watch(store.state.navegacion, () => {
      isMenuCollapsed.value = store.state.navegacion.isMenuCollapsed;
    });

    const modulosArray = computed(() => {
      return generateModules(modulos);
    });

    const accesos = computed(() => {
      return {
        registro: modulos.filter((m) => m.modulo === "Registro"),
        estructura: modulos.filter((m) => m.modulo === "Estructura"),
        ficha: modulos.filter((m) => m.modulo === "Ficha"),
        fichanoformal: modulos.filter((m) => m.modulo === "Ficha no formal"),
        busqueda: modulos.filter(
          (m) =>
            m.modulo === "Búsqueda" &&
            m.opcion != "Fotos" &&
            m.opcion != "Catastro Detalle" &&
            m.opcion != "Plano Agregar"
        ),
        habilitacion: modulos.filter((m) => m.modulo === "Habilitación"),
        documento: modulos.filter(
          (m) =>
            m.modulo === "Documento" &&
            m.opcion != "Fotos" &&
            m.opcion != "Catastro Detalle" &&
            m.opcion != "Plano Agregar"
        ),
        rentas: modulos.filter((m) => m.modulo === "Rentas"),
        catalogo: modulos.filter((m) => m.modulo === "Catalogo"),
        reporte: modulos.filter((m) => m.modulo === "Reporte"),
        estadistica: modulos.filter((m) => m.modulo === "Estadistica"),
        configuracion: modulos.filter((m) => m.modulo === "Configuración")
      };
    });

    return {
      isCollapsed,
      setCollapsed,
      modulosArray,
      accesos,
      toggleCollapsed,
      isMenuCollapsed
    };
  }
};
</script>

<style lang="less">
.midrawer {
  .ant-drawer-body {
    padding-top: 7px !important;
    padding-left: 0 !important;
  }
}
</style>
